/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import HsnCode from "../../components/HsnCode";

const AdminHsnCode = (props) => {
    return (
        <HsnCode moduleType={'Admin'} {...props} />
    )
}

export default AdminHsnCode